import * as React from 'react';

function SvgErrorGallery(props) {
  return (
    <svg viewBox="0 0 28 25" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="#ea2d00">
        <path d="M12.46 18.643a1.491 1.491 0 102.983 0 1.491 1.491 0 00-2.983 0zm.497-9.446v5.718a.25.25 0 00.249.248h1.491a.25.25 0 00.249-.248V9.197a.25.25 0 00-.249-.248h-1.491a.25.25 0 00-.249.248z" />
        <path d="M27.738 22.87L14.812.496C14.62.165 14.287 0 13.952 0s-.672.165-.861.497L.165 22.87a.994.994 0 00.86 1.492h25.853a.994.994 0 00.86-1.492zm-24.345-.868L13.952 3.726 24.51 22.002z" />
      </g>
    </svg>
  );
}

export default SvgErrorGallery;
